module.exports = __webpack_public_path__ + "img/abraham-lincoln.aca46c3c.png";